var _style, _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMetrics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-metrics_svg__Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".icon-metrics_svg__st0{fill:#101010}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-metrics_svg__st0",
    d: "M3.3 8c-.1 0-.3 0-.5-.1-.5-.3-.6-.9-.3-1.4.4-.7.8-1.3 1.4-1.9.4-.4 1-.4 1.4-.1.3.5.4 1.1 0 1.5-.4.5-.8 1-1.1 1.5-.2.3-.5.5-.9.5zm17.4 0c-.3 0-.7-.2-.9-.5-.3-.5-.7-1-1.1-1.5-.4-.4-.3-1 .1-1.4.4-.4 1-.3 1.4.1.5.6 1 1.2 1.4 1.9.3.5.1 1.1-.4 1.4h-.5zM7.9 3.9c-.4 0-.7-.3-.9-.6-.2-.5 0-1.1.5-1.3.7-.3 1.4-.6 2.2-.7.5-.1 1.1.2 1.2.8.1.5-.2 1.1-.8 1.2-.6 0-1.2.2-1.8.5-.1 0-.2.1-.4.1zm8.2 0c-.1 0-.3 0-.4-.1-.6-.3-1.2-.5-1.8-.6-.6-.1-.9-.7-.8-1.2s.6-.9 1.2-.8c.7.2 1.5.4 2.2.8.5.2.7.8.5 1.3-.2.3-.5.6-.9.6zM23 12c0 6.1-4.9 11-11 11S1 18.1 1 12v-1.1c.1-.6.5-1 1.1-.9.5 0 .9.5.9 1.1v.9c0 5 4 9 9 9s9-4 9-9v-.9c-.1-.5.3-1 .9-1.1.6-.1 1 .3 1.1.9V12z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "icon-metrics_svg__st0",
    d: "M12 13c-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4l4.4-4.4c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-4.4 4.4c-.2.2-.4.3-.7.3z"
  }))));
}

export default SvgIconMetrics;